import { Pipe, PipeTransform } from '@angular/core';

import { IClientShipping } from '../interfaces';

@Pipe({
  name: 'clientShippingAddressOverride',
  standalone: true,
})
export class ClientShippingAddressOverridePipe implements PipeTransform {

  transform(formValue :any) :Partial<IClientShipping> | null {
    if (!formValue?.ship_address) {
      return null;
    }

    return {
      id: -Math.floor(Math.random() * 100000), // temp random negative ID
      address: formValue.ship_address,
      addressLine2: formValue.ship_address_line_2 ?? '',
      city: formValue.ship_city ?? '',
      state: formValue.ship_state ?? '',
      postalCode: formValue.ship_zip ?? '',
      country: formValue.ship_country ?? '',
    };
  }

}
